// import BaseService from "@/service/BaseService";
import OtherService from "@/service/OtherService";


export default {
    uploadImg(payload) {
        return OtherService.getInstance().postData("/upload_photo",payload)
    }
}
